export const PONERA_ROUTES = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/account/forgot-password", // solo per test
  RESET_PASSWORD: "/account/reset-password", // solo per testaccount/reset-password
  CONFIRM_EMAIL: "/account/confirm",
  UNAUTHORIZED: "/unauthorized", // solo per test
  ADMIN: {
    STRINGRESOURCES: "stringresources/*",
    COMPANIES: "companies/*",
    USERS: "users/*",
    CONFIG: "config/*",
    FEEDBACK: "feedback/*",
    SOPMATRIX: "sopmatrix/*",
  },
  COMPANIESLIST: "/admin/companies",
  USERSLIST: "/admin/users",

  PACKAGING: "/packaging",
  SUSTAINABILITY: "/sustainability",
};

export const PONERA_UNAUTHENTICATED_ROUTES = [
  PONERA_ROUTES.LOGIN,
  PONERA_ROUTES.FORGOT_PASSWORD,
  PONERA_ROUTES.RESET_PASSWORD,
  PONERA_ROUTES.SIGN_UP,
  PONERA_ROUTES.CONFIRM_EMAIL,
];

export function getRoute() {
  const paramsType = Object.prototype.toString.call(arguments[1]);
  if (paramsType === "[object Object]" || paramsType === "[object Undefined]") {
    return getRouteObj(arguments[0], arguments[1]);
  } else {
    return getRouteArgs(...arguments);
  }
}

function getRouteArgs() {
  var routeRegexp = /:([^:\/]+)/gi;
  let route = arguments[0];
  const args = arguments;
  let idx = 0;
  route = route.replace(routeRegexp, function ($0, $1) {
    idx++;
    return args[idx];
  });
  return route;
}

function getRouteObj(route, replacements) {
  var routeRegexp = /:([^:\/]+)/gi;
  route = route.replace(routeRegexp, function ($0, $1) {
    return replacements && replacements[$1.replace("?", "")];
  });
  return route;
}
